import {PaletteOptions} from '@mui/material/styles';

import {foundations} from '../../foundation';
import {colors} from '../../foundation/colors';
import '../mui-styles';

export const palette: PaletteOptions = {
  mode: 'light',
  common: {
    white: colors.white,
    black: colors.black,
  },
  primary: {
    light: foundations.legacy.primaryLight,
    main: foundations.legacy.primary,
    dark: foundations.legacy.primaryDark,
    contrastText: colors.white,
  },
  secondary: {
    light: colors.gray[400],
    main: colors.gray[600],
    dark: colors.gray[800],
    contrastText: colors.black,
  },
  success: {
    light: foundations.legacy.successLight,
    main: foundations.legacy.success,
    dark: foundations.legacy.successDark,
    contrastText: colors.black,
  },
  error: {
    light: foundations.legacy.error,
    main: foundations.legacy.error,
    dark: foundations.legacy.error,
    contrastText: colors.black,
  },
  info: {
    light: foundations.legacy.infoLight,
    main: foundations.legacy.info,
    dark: foundations.legacy.infoDark,
    contrastText: colors.black,
  },
  warning: {
    light: foundations.legacy.warningLight,
    main: foundations.legacy.warning,
    dark: foundations.legacy.warningDark,
    contrastText: colors.black,
  },
  red: {
    light: foundations.colors.red[400],
    main: foundations.colors.red[600],
    dark: foundations.colors.red[800],
    contrastText: colors.black,
  },
  text: {
    primary: colors.gray[800],
    secondary: colors.gray[600],
    disabled: colors.gray[400],
  },
  grey: colors.gray,
};
